import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import { JwtService } from '@ecosure-suite/shared/util-auth';
import {
  Observable,
  BehaviorSubject,
  throwError,
  Subscription,
  Subject
} from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../apps/admin/admin-desktop/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  private static accessTokenError$: BehaviorSubject<
    boolean
  > = new BehaviorSubject<boolean>(false);

  private readonly JWT_TOKEN = environment.localStorageKey;
  private readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
  private readonly url = environment.url.token_interceptor;

  public currentToken: string;

  constructor(private jwtService: JwtService, private http: HttpClient) {
    this.currentToken = this.JWT_TOKEN;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      sessionStorage.getItem(this.currentToken) &&
      !req.url.startsWith(`/assets`) &&
      !req.url.includes(`/login`)
    ) {
      //GET INITIAL TOKEN WHEN USER LOGS IN
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.jwtService.getToken()}`
        }
      });
    }

    //DO REFRESH TOKEN WHEN THE ACCESS-TOKEN EXPIRES
    return next.handle(req).pipe(
      catchError(err => {
        // console.log(err,123);
        
        if (err.status === 400 || err.status === 0) {
          if (!TokenInterceptorService.accessTokenError$.getValue()) {
            TokenInterceptorService.accessTokenError$.next(true);

            const body = new HttpParams({
              fromObject: {
                client_id: 'ecosure-app',
                grant_type: 'refresh_token',
                refresh_token: sessionStorage.getItem(this.REFRESH_TOKEN)
              }
            });

            /**
             * * REFRESH TOKEN API CALL
             * TODO REMOVE URL STRING AND CALL FROM SOMEWHERE
             */
            return this.http.post(`${this.url}`, body).pipe(
              switchMap((event: any) => {
                // Save new Tokens

                const refresh_tokens = Object.assign({}, event);
                this.jwtService.setToken(refresh_tokens['access_token']);
                sessionStorage.setItem(
                  this.REFRESH_TOKEN,
                  refresh_tokens['refresh_token']
                );

                TokenInterceptorService.accessTokenError$.next(false);
                // Clone the request with new Access Token
                const newRequest = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${this.jwtService.getToken()}`
                  }
                });
                return next.handle(newRequest);
              }),
              /**
               * * if there is an error clear local storage and reload browser
               * ! location.reload method depricated
               */
              catchError(er => {
                sessionStorage.clear();
                window.location.reload();
                return throwError(er);
              })
            );
          } else {
            // If it's not the first error, it has to wait until get the access/refresh token
            return this.waitNewTokens().pipe(
              switchMap((event: any) => {
                // Clone the request with new Access Token
                const newRequest = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${this.jwtService.getToken()}`
                  }
                });
                return next.handle(newRequest);
              })
            );
          }
          /**
           * * if there is an error clear local storage and reload browser
           * ! location.reload method depricated
           */
        } else if (err.status === 403 || err.status === 400) {
          sessionStorage.clear();
          window.location.reload();
        }

        // You can return the Object "err" if you want to.
        const error = err.error.message || err.statusText;

        return throwError(error);
      })
    );
  }

  // Wait until get the new access/refresh token
  private waitNewTokens(): Observable<any> {
    const subject = new Subject<any>();
    const waitToken$: Subscription = TokenInterceptorService.accessTokenError$.subscribe(
      (error: boolean) => {
        if (!error) {
          subject.next();
          waitToken$.unsubscribe();
        }
      }
    );
    return subject.asObservable();
  }
}
